import React from "react";
import sx from "./Search.module.scss";

const NoData = () => (
  <div className={sx.noData}>
    <p className={sx.header}>No Results Found</p>
    <p className={sx.msg}>
      We couldn't find any results based on your search. Please try searching
      with another term.
    </p>
    <p className={sx.msg}>
      Did you know you can search using hashtags? Visit our{" "}
      <a style={{ textDecoration: "underline", color: "blue" }} href="/faq">
        FAQs
      </a>{" "}
      to learn how.
    </p>
  </div>
);

export default NoData;
